import Image from 'next/image';

export default function UsageFlowPC() {
  return (
    <div className="c-panel u-mt50 u-w-full u-pos-rel">
      <h2 className="usage-flow__pc-title u-color-main">ご利用の流れ</h2>
      <div className="usage-flow__pc-container">
        {/* Step bar 1-3 */}
        <Image
          src="/nextjs/images/job_detail/step_bar_1-3.svg"
          alt="ステップバー 1-3"
          className="u-w-full"
          width={1200}
          height={100}
        />

        {/* First row of steps */}
        <div className="u-flex -row">
          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_registration_3.svg"
              alt="ご登録アイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">ご登録</p>
              <div className="usage-flow__pc-detail">
                <p>Webで簡単お申し込み</p>
                <p className="u-mt8">
                  ※完全無料で
                  <br />
                  ご利用いただけます
                </p>
              </div>
            </div>
          </div>

          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_counseling.svg"
              alt="カウンセリングアイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">カウンセリング</p>
              <p className="usage-flow__pc-detail">
                オンラインで転職のお悩みや希望条件をヒアリング
              </p>
            </div>
          </div>

          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_jobs_introduction_2.svg"
              alt="求人紹介アイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">求人をご紹介</p>
              <p className="usage-flow__pc-detail">
                ご希望にマッチした求人を複数ご紹介
              </p>
            </div>
          </div>
        </div>

        {/* Step bar 4-6 */}
        <Image
          src="/nextjs/images/job_detail/step_bar_4-6.svg"
          alt="ステップバー 4-6"
          className="u-w-full"
          width={1200}
          height={100}
        />

        {/* Second row of steps */}
        <div className="u-flex -row">
          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_application_document_submission.svg"
              alt="応募・書類提出アイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">応募・書類提出</p>
              <p className="usage-flow__pc-detail">
                応募書類の添削や提出も建職バンクがサポート
              </p>
            </div>
          </div>

          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_interview_preparation.svg"
              alt="選考対策アイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">選考対策</p>
              <p className="usage-flow__pc-detail">
                キャリアアドバイザーが面接練習もサポート
              </p>
            </div>
          </div>

          <div className="usage-flow__pc-item">
            <Image
              src="/nextjs/images/icons/ic_handshake.svg"
              alt="内定・ご入社アイコン"
              className="usage-flow__pc-icon"
              width={48}
              height={48}
            />
            <div className="usage-flow__pc-text-box">
              <p className="usage-flow__pc-subtitle">内定・ご入社</p>
              <p className="usage-flow__pc-detail">
                内定・ご入社後も手厚くフォロー
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
